import uploadView from "./uploadView";
import blogView from "./blogView";
import blogPage from "./blogPage";

import paginationView from "./paginationView";
import * as Model from "./model.js";
import { async } from "@firebase/util";
import { RESULT_PER_PAGE } from "./config";

import searchView from "./searchView";

const verifyPass = async function (pass, email) {
  const user = await Model.signIn(email, pass);

  if (user) {
    alert("logged in");
    uploadView._renderUpload();
  }
};

const uploadPost = async function (data, file) {
  const promise1 = await Model.writeData(data);
  const promise2 = Model.uploadImage(file, promise1.id);
  const promise3 = Model.update(promise1.id);
  const promise4 = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(location.reload());
    }, 10000);
  });

  Promise.allSettled([promise1, promise2, promise3, promise4]);
};

const removeDuplicate = async function () {
  const data = await Model.getData();

  const inbox = [];
  let inboxData = [""];
  if (data[0] !== "") {
    const unique = data.filter((curdata) => {
      for (const blogged of Object.entries(curdata)) {
        const id = blogged[0];
        const isDuplicate = inbox.includes(curdata[id].uid);
        if (!isDuplicate) {
          inbox.push(curdata[id].uid);
          return true;
        }
        return false;
      }
    });
    inboxData = unique;
  }

  return inboxData;
};

const blogData = async function () {
  const data = await removeDuplicate();
  const image = await Model.getImage();

  const finalBlogData = data.map(async (blog, index, data) => {
    for (const blogId of Object.entries(blog)) {
      const id = blogId[0];
      const img = await image[index];
      const unique = img.find((dataBlog) => {
        return id === dataBlog.id.split("/")[1];
      });
      return [blog, unique];
    }
  });

  const dataMap = finalBlogData.map(async (data) => {
    const blogged = await data;

    for (const blogId of Object.entries(blogged[0])) {
      const id = blogId[0];
      const blogData = blogged[0];
      const blogImg = blogged[1];

      const procesedData = {
        text: blogData[id].text,
        url: blogImg.url,
        title: blogData[id].title,
        uid: id,
        time: blogData[id].time,
      };

      const checkedData = (Model.state.updated = procesedData);
      return checkedData;
    }
  });

  Model.state.dataBlog = dataMap;
  const data2 = Model.getResultPerpAGE(dataMap, Model.state.page);

  if (data2.length === 0) {
    blogView._errorMessage();
  }

  const latest = dataMap.slice(-4);
  const stamps = [];

  blogView._blogPost ? (blogView._blogPost.innerHTML = "") : "";

  for (const datal of data2) {
    const uploadData = await datal;

    blogView._renderUpload(uploadData);
  }

  for (const datal of latest) {
    const uploadData = await datal;
    stamps.push(uploadData.time);
  }

  const sortedStamps = stamps.sort((a, b) => b - a);

  sortedStamps.map(async (accData, index) => {
    if (!accData) return;
    const blog = await dataMap[index];

    blogView._renderSideBlog(blog);
  });

  paginationView._render(data, RESULT_PER_PAGE, Model.state.page);
  return dataMap;
};

const pagination = async function (goto, returned) {
  const data = await removeDuplicate();
  const data2 = await Model.getResultPerpAGE(returned, goto);
  console.log(data2);
  const latest = Model.state.blogs.slice(-4);
  blogView._clear();

  for (const datal of data2) {
    const uploadData = await datal;
    blogView._renderUpload(uploadData);
  }
};

const getSearchResults = async function (data3, handler) {
  searchView._addSpinner();

  const image = await Model.getImage();
  const blog = Model.state.blogs;

  const lay = blog.find((blogd, index) => {
    for (const blogId of Object.entries(blogd)) {
      const idBlog = blogId[0];
      const {
        [idBlog]: { title },
      } = blogd;

      if (title.toLowerCase().includes(data3.toLowerCase())) {
        const imgFind = image.map(async (data) => {
          const img = (await data).at(0);
          blogd[idBlog].uid = idBlog;

          if (img.id.split("/")[1] === blogd[idBlog].uid) {
            blogd[idBlog].url = img.url;
            document.querySelector(".error")
              ? (document.querySelector(".error").innerHTML = "")
              : "";
            searchView._addSearchResults(blogd[idBlog]);
          }
        });
      } else {
        searchView._latest.innerHTML = "";
        searchView._latest.insertAdjacentHTML(
          "beforeend",
          "<p class='error'>No Result Found</p>"
        );
      }
    }
  });
};

const getBlogData = async function (id) {
  const image = await Model.getImage();
  const data2 = await Model.getBlog(id);

  console.log(data2);

  const imgFind = image.map(async (data) => {
    const img = (await data).at(0);
    if (img.id.split("/")[1] === data2.uid) {
      data2.url = img.url;

      localStorage.setItem("blogData", JSON.stringify(data2));
      location.href = "/blogpage/index.html";
    }
  });
};

const updateBlog = async function (info) {
  const timeStamp = new Date().getTime();
  const promise1 = await Model.getBlog(info.uid);

  promise1.commentData.push({
    [timeStamp]: {
      name: info.text,
      comment: info.message,
      email: info.email,
      time: timeStamp,
    },
  });

  const promise2 = await Model.storeComment(promise1);

  const promise3 = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(location.reload());
    }, 1000);
  });

  Promise.allSettled([promise1, promise2, promise3]);
};

const comment = async function () {
  const blog = JSON.parse(localStorage.getItem("blogData"));
  const data = await Model.getBlog(blog.uid);

  data?.commentData?.map(async (data) => {
    if (data !== "") {
      for (const dataEntries of Object.entries(await data)) {
        const time = Model.timeAgo(dataEntries[1].time);
        blogPage._renderComments(dataEntries[1], time);
      }
    } else blogPage._renderComments("", "");
  });
};

const init = async function () {
  uploadView._addHandlerPass(verifyPass);
  uploadView._addHandlerSubmit(uploadPost, Model.state.id);
  blogView._addHandlerMore(getBlogData);
  const returned = await blogData();
  searchView._addHandler(getSearchResults, returned);
  paginationView._addHandler(pagination, returned);
  blogPage.uploadComment(updateBlog);
  comment();
};

init();

const bar = document.querySelector(".fa-bars");
const cancel = document.querySelector(".fa-xmark");
const nav_bar = document.querySelector(".nav_bar");
const body = document.querySelector("body");
body.addEventListener("click", (e) => {
  const target1 = e.target.classList.contains("fa-bars");
  const target2 = e.target.classList.contains("fa-xmark");
  if (target1 || target2) nav_bar.classList.toggle("hidden");
});
